import { isSafeInternalPath } from "@/lib/authRouting";

const BLOCKED_AUTH_PATHS = [
  "/login",
  "/register",
  "/auth",
  "/onboarding",
  "/accept-invite",
  "/no-org-access",
  "/member-disabled",
  "/access-locked",
] as const;

let lastAppLocation: string | null = null;

function pathWithoutSearch(path: string): string {
  return path.split(/[?#]/, 1)[0] ?? path;
}

export function isSettingsPath(pathname: string): boolean {
  const path = pathWithoutSearch(pathname);
  return path === "/settings" || path.startsWith("/settings/");
}

function isBlockedAuthPath(pathname: string): boolean {
  const path = pathWithoutSearch(pathname);
  return BLOCKED_AUTH_PATHS.some((blocked) => path === blocked || path.startsWith(`${blocked}/`));
}

export function rememberSettingsReturnTo(pathname: string, search = "", hash = ""): void {
  if (!isSafeInternalPath(pathname) || isSettingsPath(pathname) || isBlockedAuthPath(pathname)) {
    return;
  }
  lastAppLocation = `${pathname}${search}${hash}`;
}

export function resolveSettingsReturnTo(fallback: string): string {
  if (
    lastAppLocation &&
    isSafeInternalPath(lastAppLocation) &&
    !isSettingsPath(lastAppLocation) &&
    !isBlockedAuthPath(lastAppLocation)
  ) {
    return lastAppLocation;
  }
  return fallback;
}

export function resetSettingsReturnTo(): void {
  lastAppLocation = null;
}
